import React from "react";
import { PreviewLayout } from "@/components/previews";
import { QRProps } from "@/contexts/QREditorContext/types";
import { NextImage } from "@/components/NextImage";
import "./PreviewUrlUnified.scss";

export interface PreviewUrlUnifiedProps {
  /** Props del QR (url o url-static) */
  qrProps: QRProps<"url"> | QRProps<"url-static">;
  /** Página para PreviewLayout */
  page: "url" | "url-static";
  /** Data QA para testing */
  dataQA: string;
  /** Clave de traducción */
  translationKey: "url" | "url_static";
}

/**
 * Lógica unificada para PreviewUrl y PreviewUrlStatic
 * Elimina la duplicación de código entre ambos componentes
 */
export function PreviewUrlUnified({
  qrProps,
  page,
  dataQA,
  translationKey,
}: PreviewUrlUnifiedProps) {
  // Handle both data types (url vs url-static have different structures)
  //TODO: CHECK THIS LOGIC in URL PREVIEW
  const qrUrlLink = page === "url" || page === "url-static" ? qrProps?.data?.qrUrlLink : undefined;

  const t = qrProps.previewTranslations?.[translationKey];

  const conditionalPreviewRender = () => {
    if (qrProps?.preview) {
      return (
        <>
          <div className="preview-url-unified__browser-url">
            {qrUrlLink ? qrUrlLink : "www.mywebsite.com"}
          </div>
          <NextImage
            src="/images/phone-previews/defaultPreview/preview_URL.png"
            width={241}
            height={512}
            alt="url preview"
            loading="lazy"
            className="preview-url-unified__image"
          />
          <p className="preview-url-unified__text">
            {t?.preview_url_title_1} <br /> {t?.preview_url_title_2}
          </p>
        </>
      );
    } else {
      // Direct redirect when not preview
      window.location.href = qrUrlLink;
    }
  };

  //TODO ESTA PREVIEW UNIFICADA SERA LA QUE SE USE EN URL Y URL-STATIC (PreviewLayout SE DEBE REEMPLAZAR POR PHONELAYOUT)

  return (
    <PreviewLayout
      page={page}
      dataQA={dataQA}
      includeBrowser
    >
      {conditionalPreviewRender()}
    </PreviewLayout>
  );
}
